import { defineRecipe } from '@chakra-ui/react';
import { jammingVariant } from '@theme/variants/button/jamming.variant';

import {
  calendarVariant,
  cockpitHeaderVariant,
  contextMenuVariant,
  headOptionVariant,
  lg,
  md,
  pickVariant,
  playerVariant,
  positionPickerVariant,
  primaryVariant,
  replayVariant,
  screenStd,
  secondaryVariant,
  sm,
  smallPlayerVariant,
  toggleIconVariant,
  toggleM,
  toggleS,
  toggleVariant,
  transparentVariant,
} from '../variants/button';

export const buttonRecipe = defineRecipe({
  className: 'chakra-button',
  base: {
    width: 'fit-content',
    fontWeight: 'regular',
    fontSize: '16px',
    fontFamily: 'roboto',
    borderRadius: 0,
    outline: 'none !important',
    _disabled: {
      cursor: 'default',
    },
  },
  variants: {
    variant: {
      primary: primaryVariant,
      secondary: secondaryVariant,
      toggle: toggleVariant,
      toggleIcon: toggleIconVariant,
      headOption: headOptionVariant,
      contextMenu: contextMenuVariant,
      calendar: calendarVariant,
      pick: pickVariant,
      player: playerVariant,
      positionPicker: positionPickerVariant,
      replayTimelineBackwardForward: replayVariant,
      smallPlayer: smallPlayerVariant,
      transparent: transparentVariant,
      cockpitHeader: cockpitHeaderVariant,
      jamming: jammingVariant,
    },
    size: {
      sm,
      md,
      lg,
      toggleM,
      toggleS,
      screenStd,
    },
    addon: {
      icon: {
        '& [data-part="iconBox"]': {
          boxSize: 'min-content',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'sm',
  },
  compoundVariants: [
    {
      variant: 'toggle',
      addon: 'icon',
      css: {
        padding: 0,
        width: '100%',
        justifyContent: 'flex-start',
      },
    },
  ],
});
